<template>
  <div>
    <div class="table-wapper" ref="toolbarTable">
    <table :key="keyTable">
      <thead :key="keyTable">
        <tr class="tittle-table">
          <th class="min_width" v-if="getName() !== reportType.productSold && getName() !== 'revenueByProduct' && getName() !== 'revenueByCategory'">{{ $t('date') }}</th>
          <th class="min_width" v-if="getName() === 'revenueByCategory'">{{ $t('category') }}</th>
          <th v-for="(colName, index) in colsData" :key="index" @click="getReportData(colName.key)" v-bind:class="{pointer: isSortField(colName.key)}">
            {{ $t(colName.label) || colName }}
            <span v-if="colName.key === sortField && isSortField(colName.key)" v-bind:class="{reverse: sortDesc}">
              <UiBaseIcon v-if="!sortDesc" iconName="arrowDown" height="18" width="18" />
              <UiBaseIcon v-if="sortDesc" iconName="arrowDown" height="18" width="18" />
            </span>
          </th>
        </tr>
      </thead>
      <tbody v-if="itemsLength() > 0 && getName() !== reportType.payment && getName() !== reportType.productSold && getName() !== 'revenueByProduct' && getName() !== reportType.productSoldByCategory && getName() !== 'revenueByOutlet'">
        <tr class="total-rows total_report" v-if="getName() !== 'revenueByCategory'">
          <td>{{ $t('summary') }}</td>
          <td class="text-right" v-for="(colName, index) in colsData" :key="index">{{ totalPriceByCol(colName.key || colName) }}</td>
        </tr>
        <tr v-for="(item, index) in Object.keys(report.items)" :key="index">
          <td>{{ getName() !== 'revenueByCategory' ? formartDate(item) : item }}</td>
          <td class="text-right" v-for="(el, idx) in colsData" :key="idx">{{ getTableData(report.items[item], el) }}</td>
        </tr>
      </tbody>
      <tbody v-if="itemsLength() > 0 && (getName() === reportType.payment || getName() === 'revenueByOutlet')">
        <tr class="total-rows total_report">
          <td>{{ $t('summary') }}</td>
          <td class="text-right" v-for="(colName, index) in colsData" :key="index">{{ totalPaymentByCol(colName) }}</td>
        </tr>
        <tr v-for="(item, index) in Object.keys(report.items)" :key="index">
          <td>{{ formartDate(item) }}</td>
          <td class="text-right" v-for="(el, idx) in colsData" :key="idx">{{ getTableData(item, el) }}</td>
        </tr>
      </tbody>
      <tbody v-if="itemsLength() > 0 && (getName() === 'revenueByProduct')">
        <tr v-for="(item, index) in getReportData()" :key="index">
          <td v-for="(el, idx) in colsData" :key="idx">
            <p class="break-line">
              {{ getTableRevenueByProductData(item, el.key) || 0 }}
            </p>
          </td>
        </tr>
      </tbody>
      <tbody v-if="itemsLength() > 0 && (getName() === reportType.productSold)">
        <tr v-for="(item, index) in getReportData()" :key="index">
          <td v-for="(el, idx) in colsData" :key="idx">
            <p class="break-line">
              {{ getTableProductSoldData(item, el.key) }}
            </p>
          </td>
        </tr>
      </tbody>
      <tbody v-if="itemsLength() > 0 && (getName() === reportType.productSoldByCategory)">
        <tr v-for="(item, index) in report.items" :key="index">
          <td v-for="(el, idx) in colsData" :key="idx">
            <p class="break-line">
              {{ getTableProductSoldData(item, el.key) }}
            </p>
          </td>
        </tr>
      </tbody>
      <tbody v-if="itemsLength() <= 0">
        <tr class="no-data">
          <td colspan="12">{{$t('no_data')}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="pagination" v-if="count_items / getQuery.limit > 1 && showPagination">
    <Pagination :page="getQuery.page - 1" :total="count_items" :limit="getQuery.limit" @getDataTable="getDataTable"/>
  </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import reportType from '@/config/reportType'
import moment from 'moment'
// import currencyFormatter from 'currency-formatter'
import formatNum from 'format-num'
import { getItemByLocalStorage } from '@/utils/localStorage'
import localStorageKey from '@/constants/localStorageKey'
import UiBaseIcon from '@/components/icons/UiBaseIcon'
import Pagination from '@/components/UiPagination'
import i18n from '@/i18n'
export default {
  name: 'UiTableReportCommon',
  components: {
    UiBaseIcon,
    Pagination
  },
  props: {
    report: {
      type: Object,
      default: () => {}
    },
    colsData: {
      type: Array,
      default: () => []
    },
    showPagination: {
      type: Boolean,
      default: false
    },
    typeGetData: {
      type: String,
      default: '',
      require: false
    }
  },
  data () {
    return {
      groupedData: [],
      conferenceDay: [],
      reportType: {
        productSold: 'productSold',
        productSoldByCategory: 'productSoldByCategory',
        payment: 'payment'
      },
      sortField: null,
      sortDesc: true,
      keyTable: 0
    }
  },
  computed: {
    ...mapGetters({
      getListOutLet: 'outlet/getListOutLet',
      count_items: 'report/getCountItems',
      getQuery: 'report/getQuery',
      getIsChangeStore: 'report/getIsChangeStore'
    })
  },
  watch: {
    getQuery: function (news, old) {
      if (news.page !== old.page) {
        this.$refs.toolbarTable.scrollTop = 0
      }
      if (!this.getIsChangeStore) {
        this.report.items = []
      }
      this.keyTable = Math.random()
      this.setChangeStore(false)
    }
  },
  methods: {
    ...mapActions({
      getReport: 'report/getReportDataByStore',
      setChangeStore: 'report/setChangeStore'
    }),
    moment (any) {
      return moment(any)
    },
    isSortField (col) {
      if (this.getName() !== 'revenueByProduct' && this.getName() !== 'productSold') {
        return false
      }

      if (col !== 'totalPrice' && col !== 'cost' && col !== 'grossProfit' && col !== 'totalQtySold' && col !== 'totalQtyRefund' && col !== 'netQtySold') {
        return false
      }

      return true
    },
    getReportData (col) {
      if (this.getName() !== 'revenueByProduct' && this.getName() !== 'productSold') {
        return
      }
      if (col && !this.isSortField(col)) {
        return
      }

      let list = this.report.items
      if (col === this.sortField) {
        this.sortDesc = !this.sortDesc
      }

      if (col) {
        this.sortField = col
        list = this.report.items.sort((b, a) => this.sortDesc ? Number(a[col] || 0) - Number(b[col] || 0) : Number(b[col] || 0) - Number(a[col] || 0))
      }
      return list
    },
    getName () {
      return this.$route.name
    },
    getTableData (reportItem, col) {
      if (typeof reportItem === 'string') {
        return this.formatTotal(this.report.items[reportItem][col])
      }
      if (typeof reportItem[col] === 'string' || typeof reportItem[col] === 'number') {
        return this.formatTotal(reportItem[col])
      }
      if (col.key === 'revNewCustomer' && reportItem[col.key] === undefined) {
        return i18n.t('n_a')
      }
      return col.key === 'orderCount'
        ? reportItem[col.key] || 0
        : col.key === 'avgItemCount'
          ? reportItem[col.key]
            ? parseFloat(reportItem[col.key]).toFixed(2)
            : 0
          : this.formatTotal(reportItem[col.key])
    },
    getTableRevenueByProductData (reportItem, col) {
      if (col === 'sku' || col === 'name' || col === 'margin') {
        return reportItem[col]
      }
      if (col === 'additionalData') {
        var nameKey = 'items_name'
        if (reportItem[col] && reportItem[col][nameKey]) {
          return reportItem[col][nameKey].replace(',', '\n')
        }
        return ' '
      }
      var currencyExchangeRateKey = 'currencyExchangeRate'
      var presentmentCurrencyKey = 'presentmentCurrency'
      return this.formatTotal(reportItem[col], reportItem[currencyExchangeRateKey], reportItem[presentmentCurrencyKey])
    },
    getTableProductSoldData (reportItem, col) {
      if (col === 'additionalData') {
        var nameKey = 'items_name'
        if (reportItem[col] && reportItem[col][nameKey]) {
          return reportItem[col][nameKey].replace(',', '\n')
        }
        return ' '
      }
      if (col === 'sku') {
        return reportItem[col] || ''
      }
      return reportItem[col] || 0
    },
    onChangeOutlet (reportingMode, outletIds, registerIds, day, type, states, statuses) {
      this.day = day
      this.query.outletIds = outletIds
      this.query.registerIds = registerIds
      this.query.reportingMode = reportingMode
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    onDefaultFilter (day, type) {
      this.day = day
      this.filterType = type
      this.query.mode = type
      this.getReport({
        type: reportType.saleSummary,
        query: {
          ...this.query,
          ...day
        }
      })
    },
    formartDate (date) {
      if (date.length < 8) {
        if (date.toLowerCase().includes('week')) {
          return date.toLowerCase().replace('week', i18n.t('week'))
        }
        return date
      }
      const dateRes = new Date(moment(date).toDate())

      return i18n.d(dateRes, 'short')
    },
    formatTotal (total, currencyExchangeRate = null, presentmentCurrency = null) {
      const storeConfig = getItemByLocalStorage(localStorageKey.STORE_CONFIG)
      const currentCurrent = getItemByLocalStorage(localStorageKey.CURRENT_CURRENCY) || {}
      const toCurrencyKey = 'toCurrency'
      const toCurrency = currentCurrent[toCurrencyKey]
      var rate = presentmentCurrency && currencyExchangeRate && (toCurrency === presentmentCurrency) ? currencyExchangeRate : (currentCurrent?.rate || '1')
      return `${currentCurrent?.symbol || storeConfig.symbol} ${formatNum((Number(total) * Number(rate)).toFixed(2), { maxFraction: 2 })}`
    },
    totalPaymentByCol (colName) {
      if (this.report === undefined || this.report.items === undefined) {
        return this.formatTotal(0)
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += parseFloat(this.report.items[item][colName] ? parseFloat(this.report.items[item][colName]) : 0)
      })

      return this.formatTotal(total)
    },
    totalPriceByCol (colName) {
      if (this.report === undefined || this.report.items === undefined) {
        return this.formatTotal(0)
      }

      if (colName === 'avgOrderValue') {
        let totalRevenue = 0
        let totalOrder = 0
        Object.keys(this.report.items).forEach(item => {
          totalRevenue += parseFloat(this.report.items[item].totalRevenue ? parseFloat(this.report.items[item].totalRevenue) : 0)
          totalOrder += parseFloat(this.report.items[item].orderCount ? parseFloat(this.report.items[item].orderCount) : 0)
        })
        return this.formatTotal(totalRevenue / totalOrder)
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += parseFloat(this.report.items[item][colName] ? parseFloat(this.report.items[item][colName]) : 0)
      })
      if (colName === 'avgOrderValue' || colName === 'avgItemCount') {
        const avgValue = (total / Object.keys(this.report.items).length).toFixed(2)
        return colName === 'avgOrderValue' ? this.formatTotal(avgValue) : avgValue
      }
      return colName === 'orderCount' ? total : this.formatTotal(total)
    },
    itemsLength () {
      if (this.report === undefined || this.report.items === undefined) {
        return 0
      }

      let total = 0
      Object.keys(this.report.items).forEach((item) => {
        total += 1
      })
      return total
    },
    getOutletName (code) {
      const outlet = this.getListOutLet.find((outlet) => outlet.id === code)
      if (outlet) {
        return outlet.name
      }
      return ''
    },
    groupBy (array, fn) {
      const result = {}
      array.forEach((item) => {
        const key = fn(item)

        if (!result[key]) {
          result[key] = []
        }
        result[key].push(item)
      })
      return result
    },
    getDataTable (currentPage) {
      this.getReport({
        type: this.typeGetData,
        query: {
          ...this.query,
          page: currentPage
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.table-wapper {
  overflow-x: auto;
  table {
    width: 100%;
    color: #333;
    border: 0 solid #e4e3e4;
    border-collapse: collapse;
    border-spacing: 0;
    background-color: #fff;
    border-width: 1px 0 0 1px;
    border-radius: 7px;
    letter-spacing: 0;
    font-size: 15px;
    font-weight: 400;
    td,
    tr,
    th {
      border: 1px solid #e4e3e4;
      padding: 15px 5px;
      vertical-align: middle;
      .pointer {
        cursor: pointer;
        .reverse {
          >span {
            transform: rotate(180deg)
          }
        }
      }
    }
    tr td:first-child {
      text-transform: capitalize;
    }
    .tittle-table {
      color: #fff;
      background-color: #92a1ab;
      border-top-left-radius: 7px;
      border-top-right-radius: 7px;
      th {
        font-size: 16px;
        font-weight: bold;
        text-transform: capitalize;
        border-bottom-width: 1px;
        text-align: center;
        padding: 15px 5px;
        border: 1px solid #e4e3e4;
        vertical-align: middle;
      }
    }
    .text-center {
      text-align: center;
    }
    .text-right {
      text-align: right;
    }
    .min_width {
      min-width: 150px;
    }
    .report_name {
      min-width: 230px;
    }
    .report_total {
      width: 100px;
    }
  }
}
</style>
